import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

let nextInstanceId = 0;

@Component({
  selector: 'dcc-collapsible-panel',
  templateUrl: './collapsible-panel.component.html',
  styleUrls: ['./collapsible-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollapsiblePanelComponent {
  @Input() title = '';

  isExpanded = true;

  private readonly instanceId = ++nextInstanceId;
  readonly bodyId = `dcc-collapsible-panel-body-${this.instanceId}`;
  readonly titleId = `dcc-collapsible-panel-title-${this.instanceId}`;

  toggle(): void {
    this.isExpanded = !this.isExpanded;
  }
}
